import gql from 'graphql-tag';

export const GET_PAYMENT_HISTORY = gql`
  query GetPayments($offset: Int, $limit: Int) {
    guarantor {
      payments(offset: $offset, limit: $limit) {
        receiptNumber
        amount
        date
        description
        numberOfVisits
        status
      }
    }
  }
`;
